export default abstract class Preferences {}



// WEBPACK FOOTER //
// ./src/models/resource-management/preferences.ts